import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

let focusedTriggerId = null;
let helpers = require('../modules/helpers.js');

$(document).ready(function () {
    // Prevent unexpected submission of form
    $(document).on('keydown', '.form__input', function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    });

    formInput();
    formCheckBox();
    formSelect();
    formDatepicker();
    formInputNumber();
});

$(window).on('load', function () {
    const $input = $('.form__input');
    $input.each(function () {
        if (!$(this).val()) {
            return;
        }
        const $closest = $(this).closest('.form__col');
        const $label = $closest.find('.form__label');
        $label.addClass('form__label--focus');

    });
});

document.addEventListener('wpcf7submit', function (event) {
    if (event.detail.status === 'mail_sent') {
        $('.form__label').removeClass('form__label--focus');
    }
}, false);

document.addEventListener('wpcf7mailsent', function (event) {
    if ('redirect_link' in event.detail.apiResponse) {
        $('.wpcf7-response-output', $(event.target)).attr('hidden', true);
        window.location.href = event.detail.apiResponse['redirect_link'];
        return false;
    }
}, false);

document.addEventListener('wpcf7invalid', function () {
    $('.form__input--radio-wrapper').each(function () {
        const $this = $(this);
        $this.find('.wpcf7-not-valid-tip').appendTo($this.parent());
    });
}, false);

/**
 * formInputFocusIn
 * @param event
 */
function formInputFocusIn(event) {
    const $closest = $(event.target).closest('.form__col');
    const $label = $closest.find('.form__label');
    $label.addClass('form__label--focus');
    const $newsletterLabel = $closest.find('.newsletter__label');
    $newsletterLabel.addClass('newsletter__label--focus');
}

/**
 * formInputFocusOut
 * @param event
 */
function formInputFocusOut(event) {
    if ($(event.target).val() !== '') {
        return true;
    }
    let $closest = $(event.target).closest('.form__col');
    let $label = $closest.find('.form__label');
    $label.removeClass('form__label--focus');
    let $newsletterLabel = $closest.find('.newsletter__label');
    $newsletterLabel.removeClass('newsletter__label--focus');
}

/**
 * formInput
 * @return void
 */
function formInput() {
    const $field = $('.form__input');
    $field.on('click tap keyup', function (event) {
        formInputFocusIn(event);
    });
    $field.on('blur', function (event) {
        formInputFocusOut(event);
    });
}

/**
 * formCheckBox
 * @return void
 */
function formCheckBox() {
    let $label = $('.form__input--checkbox .wpcf7-list-item-label');
    $label.attr('tabindex', 0).closest('.form__col').find('.wpcf7-form-control-wrap').addClass('form__input--checkbox-wrapper');
    $label.on('click tap keyup', function (event) {
        if (event.keyCode === undefined) {
            formCheckboxTrigger(event);
        } else if (event.keyCode === 13) {
            formCheckboxTrigger(event);
        }
        return false;
    });
}

/**
 * formCheckboxTrigger
 * @param event
 * @return void
 */
function formCheckboxTrigger(event) {
    let currChkbx = $(event.target).prev('input[type="checkbox"]');
    currChkbx.click();
}

function formSelect() {
    const $select = $('.form__input--select');
    const $wrapper = $select.closest('.form__col');
    $wrapper.find('.wpcf7-form-control-wrap').addClass('form__input--select-appearance');
}

function formDatepicker() {
    $(document).on('click tap keyup', '.form__input--date', function (event) {
        if (event.keyCode === undefined) {
            formDatepickerTrigger(event);
        }
        if (event.keyCode === 13) {
            formDatepickerTrigger(event);
        }
    });
}

/**
 * formInputNumber
 * @return boolean
 */
function formInputNumber() {
    let availableKeyCodes = [8, 9, 37, 38, 39, 40, 46];
    $(document).on('keydown', '.form__input--number', function (event) {
        if (numberRegexInput(event.key) === false && availableKeyCodes.indexOf(event.keyCode) === -1) {
            return false;
        }
    });
}

/**
 * formDatepicker
 * @param event
 * @returns {boolean}
 */
function formDatepickerTrigger(event) {
    focusedTriggerId = $(event.target).attr('id');
    $(event.target).datepicker(datepickerSettings(event));
    $(event.target).datepicker('show');
}

/**
 * Datepicker settings
 * @returns {*}
 */
function datepickerSettings(event) {
    const defaultSettings = datepickerDefaultSettings(event);
    return $.extend(defaultSettings, {
        minDate: 0
    });
}

/**
 * Datepicker defaults
 * @returns {{onChangeMonthYear: onChangeMonthYear, dateFormat: string, beforeShow: beforeShow, onSelect: onSelect}}
 */
function datepickerDefaultSettings(event) {
    return {
        dateFormat: 'mm/dd/yy',
        onSelect: function (date, datepicker) {
            formInputFocusIn(event);
            $('#' + datepicker.id).datepicker('hide').datepicker('destroy').focus();
        },
        onChangeMonthYear: function (month, year, datepicker) {
            moveTabIndexToDatepickerCells(datepicker);
        },
        beforeShow: function (elem, datepicker) {
            moveTabIndexToDatepickerCells(datepicker);
        }
    }
}

/**
 * Move focus into calendar
 * @param datepicker
 */
function moveTabIndexToDatepickerCells(datepicker) {
    setTimeout(function () {
        const $prevMonth = $('.ui-datepicker-prev:not(".ui-state-disabled")');
        const $nextMonth = $('.ui-datepicker-next:not(".ui-state-disabled")');
        const $activeCells = $('.ui-datepicker td:not(".ui-state-disabled")');

        $prevMonth.attr('tabindex', 1);
        $activeCells.each(function (idx) {
            $(this).attr('tabindex', idx + 2);
        });

        $nextMonth.attr('tabindex', $activeCells.length + 3);
        $activeCells.keyup(function (event) {
            let code = (event.keyCode ? event.keyCode : event.which);
            if (code === 13) {
                $(this).find('a').click();
                return true;
            }
        });

        $prevMonth.add($nextMonth).keypress(function (event) {
            let code = (event.keyCode ? event.keyCode : event.which);
            if (code === 13) {
                $(this).click();
                return true;
            }
        });

        $activeCells.first().focus();
    }, 0);
}

/**
 * Rooms regex input
 * @param str
 * @returns {boolean}
 */
function numberRegexInput(str) {
    const regex = /[0-9]|\./;
    return regex.test(str);
}

const totalChargeTrigger = '#daily_rate, #administrative_fees, #failure_return, #refueling_charge, #refueling_charge, #excise_tax, #start_date, #end_date';

$(document).on('blur', totalChargeTrigger, () => {
    totals();
});

$(document).ready(() => {
    totals();
});

function totals() {
    const startDateEl = '#start_date';
    const endDateEl = '#end_date';
    const dailyRateEl = '#daily_rate';
    const administrativeFeeEl = '#administrative_fees';
    const failureReturnEl = '#failure_return';
    const vehicleSurchargeEl = '#vehicle_surcharge';
    const refuelingEl = '#refueling_charge';
    const exciseTaxEl = '#excise_tax';
    const totalEl = '#estimated_total_charges';
    const totalViewEl = '#estimated_total_charges_view';

    let startDate = new Date();
    let endDate = new Date();
    let days;
    let rate = 0;
    let administrativeFee = 0;
    let failureReturn = 0;
    let vehicleSurcharge = 0;
    let refueling = 0;
    let exciseTax = 0;
    let total;

    if (!helpers.isElementExists('.wpcf7-form')) {
        return false;
    }

    if ($(startDateEl).val().length) {
        startDate = new Date($(startDateEl).val());
    }

    if ($(endDateEl).val().length) {
        endDate = new Date($(endDateEl).val());
    }

    if ($(dailyRateEl).val().length) {
        rate = parseFloat($(dailyRateEl).val());
    }

    if ($(administrativeFeeEl).val().length) {
        administrativeFee = parseFloat($(administrativeFeeEl).val());
    }

    if ($(failureReturnEl).val().length) {
        failureReturn = parseFloat($(failureReturnEl).val());
    }

    if ($(vehicleSurchargeEl).val().length) {
        vehicleSurcharge = parseFloat($(vehicleSurchargeEl).val());
    }

    if ($(refuelingEl).val().length) {
        refueling = parseFloat($(refuelingEl).val());
    }

    if ($(exciseTaxEl).val().length) {
        exciseTax = 1 + parseFloat($(exciseTaxEl).val() / 100);
    }

    days = endDate.getDate() - startDate.getDate();

    if (days === 0) days = 1;

    vehicleSurcharge = vehicleSurcharge * days;

    total = (((rate * days) + administrativeFee + failureReturn + refueling + vehicleSurcharge) * exciseTax).toFixed(2);

    $(totalEl).val(total);
    $(totalViewEl).html(total);
}